import { JourneyCanvasState } from '../../utility/TypeDefs';
import { OpenPayloadTransformModalPayload, SetPayloadForConvergingServicesPayload } from '../TypeDefs';

/**
 * @method openPayloadTransformModal
 * @description Opens the payload transformation modal.
 * @param {JourneyCanvasState} state - The current state of the journey canvas.
 * @param {OpenPayloadTransformModalPayload} payload - The payload containing the nodeId.
 * @returns {JourneyCanvasState} The updated state of the journey canvas.
 */
export const openPayloadTransformModal = (state: JourneyCanvasState, { nodeId }: OpenPayloadTransformModalPayload): JourneyCanvasState => {
  const services: {
    value: string;
    name: string;
  }[] = [];
  state.flowConnectors.forEach((node) => {
    if (node.toNodeId === nodeId) {
      services.push({
        value: node.fromNodeId,
        name: state.flowItemDataMap[node.fromNodeId].serviceName
      });
    }
  });

  return {
    ...state,
    dropDownServicesPayload: [...services],
    showTransformPayloadModal: true,
    payloadTransformationEventName: state.flowItemDataMap[nodeId].ingressEvent,
    payloadTransformationEventVersion: state.flowItemDataMap[nodeId].ingressEventVersion,
    payloadTransformationNodeId: nodeId
  };
};

/**
 * @method setPayloadForConvergingServices
 * @description Sets the payload for converging services and updates the state of the journey canvas.
 * @param {JourneyCanvasState} state - The current state of the journey canvas.
 * @param {SetPayloadForConvergingServicesPayload} payload - The payload containing the payloadData.
 * @returns {JourneyCanvasState} The updated state of the journey canvas.
 */
export const setPayloadForConvergingServices = (state: JourneyCanvasState, { payloadData, nodeId }: SetPayloadForConvergingServicesPayload): JourneyCanvasState => {
  const node = state.flowItems.find((fi) => fi.nodeId === nodeId);
  if (node) {
    node.isPayloadTransformationDataSelected = payloadData.length > 0;
    node.revision = node.isPayloadTransformationDataSelected ? 43 : 81;
  }
  return {
    ...state,
    flowItems: [...state.flowItems],
    payloadTransformations: payloadData,
    showTransformPayloadModal: false
  };
};

/**
 * @method closePayloadTransformModal
 * @description Closes the payload transformation modal.
 * @param {JourneyCanvasState} state - The current state of the journey canvas.
 * @returns {JourneyCanvasState} The updated state of the journey canvas.
 */
export const closePayloadTransformModal = (state: JourneyCanvasState): JourneyCanvasState => ({
  ...state,
  showTransformPayloadModal: false,
});
